import createGraphqlClient from "@/utils/apollo";

export const fragments = {
	Employee: `
        fragment Employee on CminsideEmployee {
            id
            name
            dob
            code
            email
            phone
            can_update
            can_delete
            display_name
            is_student
            department {
                ...Department
            }
            title {
                ...Title
            }
			titles {
				id
				name
				department {
					id
					name
				}
			}
            user_id
            chat_uid
            avatar(w: 100, h: 100)
            cluster_id
            gender
            cluster {
                name
                company {
                    name
                    address
                    logo (w: 90, h: 90)
                }
            }
            user {
                is_activated
                login
                can_update
                can_delete
            }
            pending_user {
                id
                first_name
            }
            tags {
				id
				name
			}
			employee_points {
				id
				school_year
				semester
				course_point
				school_training_point
				dormitory_training_point
				files
				confirmed
				created_at
				updated_at
				attachs {
					id
					path
					file_name
					extension
				}
				is_current
			}
			point_events {
				id
				school_year
				semester
				notes
				created_at
				updated_at
				point_event  {
					id
					name
					point
				}
			}
			properties
        }
    `,
	Department: `
        fragment Department on DepartmentType {
            id
            name
            code
        }
    `,
	Title: `
        fragment Title on TitleType {
            id
            name
        }
    `,
	Tag: `
        fragment Tag on CminsideEmployee {
            id
            name
        }
    `,
	Category: `
        fragment Category on CminsideCategory {
            id
            title
        }
    `,
	Post: `
        fragment Post on CminsidePost {
            id
			content
			category{
				id
				title
			}
			liked
			likes
			can_edit
			can_delete
			created_at
			bookmarked
			totalComment
			author {
				id
				name
				avatar(w: 90, h: 90)
			}
			people {
				id
				name
				avatar(w: 90, h: 90)
			}
			files {
				id
				file_name
				file_size
				path
				extension
			}
        }
    `,
	Posts: `
        fragment Posts on CminsidePostPagination {
            data {
                ...Post
            }
            total
            has_more_pages
        }
    `,
	Comment: `
        fragment Comment on CminsideComment {
            id
            content
            post_id
            employee_id
            parent_id
            created_at
			updated_at
            author {
                id
                name
                avatar
            }
			attachs {
				id
				path
				file_name
				extension
			}
        }
    `,
	Comments: `
        fragment Comments on CminsideCommentPagination {
            data {
				id
				content
				post_id
				employee_id
				parent_id
				created_at
				updated_at
				author {
					id
					name
					avatar
				}
				attachs {
					id
					path
					file_name
					extension
				}
            }
            total
            has_more_pages
        }
    `
};

export default createGraphqlClient("cminside");
